import { apiClient } from 'api/trpc/trpc-client'
import { observer } from 'mobx-react-lite'
import useStore from 'reusable/mobx-store-utils/useStore'
import Loader from 'reusable/mobx-helpers/Loader'
import useInitialMount from 'reusable/hooks/useInitialMount'
import { formHandler, FormHandlerConfig } from 'reusable/mobx-store-utils/form-handlers/new/form-handler'
import GapAutocompleteSingle from 'features/gap-components/autocomplete/single/GapAutocompleteSingle'
import Box from '@mui/material/Box'
import ButtonWithProgress from 'reusable/mui/progress-button/ButtonWithProgress'
import TextField from '@mui/material/TextField'

export default observer(function DevGoose() {

   const devGooseStore = useStore(() => ({
      subscribers: [] as { id: string; name: string | undefined }[],
      fields: {
         selectedUserId: '',
         command: ''
      },
      get userOptions() {
         return devGooseStore.subscribers.map(subscriber => ({
            label: subscriber.name || subscriber.id,
            id: subscriber.id
         }))
      },
      get formHandler() {
         return formHandler(devGooseStore.fields, {
            selectedUserId: { type: 'string' },
            command: { type: 'string' }
         } satisfies FormHandlerConfig)
      },
      loader: new Loader(true),
      getSubscribers: async () => {
         await devGooseStore.loader.executeLoading(async () => {
            const subscribers = await apiClient.dev.getGooseSubscribers.query()
            devGooseStore.subscribers = subscribers
         })
      },
      sendCommand: async () => {
         await devGooseStore.loader.executeLoading(async () => {
            await apiClient.dev.sendShrek.mutate({ userId: devGooseStore.fields.selectedUserId, command: devGooseStore.fields.command })
         })
      }
   }))

   useInitialMount(() => {
      devGooseStore.getSubscribers()
   })

   return <Box sx={{ maxWidth: 400 }}>
      {devGooseStore.formHandler.selectedUserId.bindInput(ip =>
         <GapAutocompleteSingle
            options={devGooseStore.userOptions}
            loading={devGooseStore.loader.isLoading}
            label="Select user"
            {...ip}
         />
      )}
      {devGooseStore.formHandler.command.bindInput(ip =>
         <TextField
            autoFocus
            fullWidth
            label="Command(ex. shrek)"
            {...ip}
            sx={{ mt: 3 }}
         />)}
      <ButtonWithProgress
         loading={devGooseStore.loader.isLoading}
         variant="outlined"
         fullWidth
         sx={{ height: '56px', borderRadius: '8px', mt: 3 }}
         disabled={!devGooseStore.fields.selectedUserId || !devGooseStore.fields.command}
         onClick={devGooseStore.sendCommand}>
         Send
      </ButtonWithProgress>
   </Box>
})
